import styled from "styled-components";
import grain from "./../../assets/images/grain.svg";

export const Container = styled.button`
  background-color: #463048;
  cursor: pointer;
  border: none;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 12px;
  padding-bottom: 12px;
  color: #fff;
  :active {
    transform: ${(props) => (props.disabled ? "" : "translateY(1px)")};
  }
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 1px;
  border-radius: 4px;
`;
